<div class="main-container">
  <mat-card appearance="outlined">
    <mat-card-title>Desktop App Summary</mat-card-title>
    <mat-card-content>
      <table class="table mt-4">
        <tbody>
        <tr>
          <th><strong>Enabled</strong></th>
          <td>{{summaryModel.enableCounterPath | yesno}}</td>
        </tr>
        <tr *ngIf="summaryModel.enableCounterPath">
          <th><strong>Username</strong></th>
          <td>{{summaryModel.ccsUserName}}</td>
        </tr>
        <!--<tr>
          <th><strong>Password</strong></th>
          <td><app-show-hide [value]="summaryModel.counterPathPassword || '&nbsp;'"></app-show-hide></td>
        </tr>-->
        <tr *ngIf="summaryModel.enableCounterPath">
          <th><strong>First Registration</strong></th>
          <td>{{summaryModel.firstRegistrationTime | unixTime: 'M/dd/yyyy hh:mm a'}}</td>
        </tr>
        <tr *ngIf="summaryModel.enableCounterPath">
          <th><strong>Last Login</strong></th>
          <td>{{summaryModel.lastLoginTime | unixTime: 'M/dd/yyyy hh:mm a'}}</td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>

  <app-card title="Change Password" [collapsed]="true" *ngIf="summaryModel.enableCounterPath">
    <form [formGroup]="changePasswordForm" novalidate (ngSubmit)="onSubmit()">
      <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="hasError">
        Unable to change password. Please try again later.
      </div>
      <app-mat-password-input [formControl]="getFormControl('newPassword', changePasswordForm)"
                              label="New Password" name="newPassword" [submitted]="submitted"></app-mat-password-input>
      <app-mat-password-input [formControl]="getFormControl('confirmPassword', changePasswordForm)"
                              label="Re-enter New Password" name="confirmPassword" [submitted]="submitted"
                              [customErrors]="{mismatchedFields: 'Passwords do not match'}"></app-mat-password-input>

      <button type="submit" mat-raised-button color="primary" matTooltip="Save changes" [promiseBtn]="buttonSubmitPromise">
        Submit
      </button>
    </form>
  </app-card>

  <mat-card appearance="outlined" *ngIf="summaryModel.enableCounterPath">
    <mat-card-title>Download</mat-card-title>
    <mat-card-content>
      <table class="table mt-4">
        <tbody>
        <tr>
          <th><strong>Platform</strong></th>
          <th><strong>Version</strong></th>
          <th><strong>Link</strong></th>
        </tr>
        <tr *ngFor="let link of links">
          <td>{{link.platform}}</td>
          <td>{{link.version}}</td>
          <td><a href="{{link.filename}}" title="Download">Download</a></td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
</div>
